import React from 'react';
import { Quote as QuoteIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

interface Quote {
  text: string;
  textEn: string;
  textRu: string;
  textFr: string;
  textDe: string;
  textNl: string;
  textMs: string;
  character: string;
  episode: string;
  episodeEn: string;
  episodeRu: string;
  episodeFr: string;
  episodeDe: string;
  episodeNl: string;
  episodeMs: string;
}

interface SeasonQuote {
  season: number;
  quotes: Quote[];
}

export const Quotes: React.FC<{
  quotes: SeasonQuote[];
}> = ({ quotes }) => {
  const { t, language } = useLanguage();

  const getQuoteText = (quote: Quote) => {
    switch (language) {
      case 'en':
        return quote.textEn;
      case 'ru':
        return quote.textRu;
      case 'fr':
        return quote.textFr;
      case 'de':
        return quote.textDe;
      case 'nl':
        return quote.textNl;
      case 'ms':
        return quote.textMs;
      default:
        return quote.text; // 默认显示中文
    }
  };

  const getEpisodeText = (quote: Quote) => {
    switch (language) {
      case 'en':
        return quote.episodeEn;
      case 'ru':
        return quote.episodeRu;
      case 'fr':
        return quote.episodeFr;
      case 'de':
        return quote.episodeDe;
      case 'nl':
        return quote.episodeNl;
      case 'ms':
        return quote.episodeMs;
      default:
        return quote.episode; // 默认显示中文
    }
  };

  return (
    <div className="grid gap-6">
      {quotes.map((seasonQuote) => (
        <div key={seasonQuote.season} className="bg-white rounded-lg shadow-lg p-4 sm:p-6">
          <h2 className="text-xl sm:text-2xl font-bold mb-4 flex items-center gap-2">
            <QuoteIcon className="w-6 h-6 text-blue-500" />
            {t('quotes.seasonTitle', { number: seasonQuote.season })}
          </h2>
          <div className="grid gap-4 sm:grid-cols-2">
            {seasonQuote.quotes.map((quote, index) => (
              <blockquote
                key={index}
                className="border-l-4 border-blue-500 pl-4 italic bg-gray-50 p-4 rounded-r hover:shadow-md transition-shadow"
              >
                <p className="text-gray-800 text-lg mb-4">
                  "{getQuoteText(quote)}"
                </p>
                <div className="text-gray-600 mt-2 space-y-1">
                  <div className="font-medium">{quote.character}</div>
                  <div className="text-sm break-normal">
                    ({getEpisodeText(quote)})
                  </div>
                </div>
              </blockquote>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}; 